module.exports = __webpack_public_path__ + "img/vc.4910c1be.svg";